export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://katiba.humanrights.or.tz').replace(/\/$/, '');
export const SITE_NAME = 'Katiba';
export const SITE_TITLE = 'Katiba | Tanzania Constitution, Laws and Human Rights';
export const ORG_NAME = 'Legal and Human Rights Centre';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

export const DEFAULT_KEYWORDS = [
    'katiba',
    'katiba ya tanzania',
    'katiba mpya',
    'constitution',
    'tanzania constitution',
    'constitution of tanzania',
    'constitutional law',
    'tume ya katiba',
    'laws',
    'tanzania laws',
    'human rights',
    'human rights tanzania',
    'legal framework',
    'governance',
    'constitutional reform',
    'case law',
    'african court',
    'lhrc',
    'legal and human rights centre'
].join(', ');

export const CATALOG_LINKS = [
    {
        to: '/tanzania-constitution',
        title: 'Constitutions of Tanzania and Processes',
        keywords: 'Katiba ya Tanzania, Tume ya Katiba, constitution of Tanzania',
        description: 'Tanzania constitution documents, Tume ya Katiba papers, and constitutional review processes.'
    },
    {
        to: '/constitution',
        title: 'Constitutions of Other Countries',
        keywords: 'world constitutions, comparative constitutional law',
        description: 'Constitutions and constitutional texts from other countries.'
    },
    {
        to: '/journals',
        title: 'Constitutional Journals',
        keywords: 'constitutional journals, legal research, katiba journals',
        description: 'Journals and research on constitutional law, governance, and human rights.'
    },
    {
        to: '/books',
        title: 'Books on Constitution and Law',
        keywords: 'constitutional books, law books tanzania',
        description: 'Books on constitutions, legal frameworks, and governance.'
    },
    {
        to: '/reports',
        title: 'Legal and Constitutional Reports',
        keywords: 'human rights reports, constitutional reports',
        description: 'Reports on constitutional matters, policy, and human rights.'
    },
    {
        to: '/cases',
        title: 'Local Court Cases',
        keywords: 'tanzania case law, constitutional cases, local courts',
        description: 'Local court judgments and constitutional case law from Tanzania.'
    },
    {
        to: '/regional-cases',
        title: 'Regional Court Cases',
        keywords: 'african court, regional courts, human rights judgments',
        description: 'African Court and other regional court judgments.'
    },
    {
        to: '/cuttings',
        title: 'Newspaper Cuttings on Katiba',
        keywords: 'katiba cuttings, constitution news tanzania',
        description: 'Newspaper cuttings and articles on constitutional reform and the law.'
    },
    {
        to: '/audios',
        title: 'Constitutional Audio',
        keywords: 'katiba audio, constitutional discussions',
        description: 'Audio recordings on constitutional law and legal education.'
    },
    {
        to: '/videos',
        title: 'Constitutional Videos',
        keywords: 'katiba videos, constitutional debates',
        description: 'Videos on constitutional law, governance, and human rights.'
    },
    {
        to: '/other',
        title: 'Other Legal Materials',
        keywords: 'legal articles, papers, dissertations',
        description: 'Articles, papers, and other legal reference materials.'
    }
];

export const ROUTE_SEO = {
    '/': { ns: 'homePage', keywords: DEFAULT_KEYWORDS },
    '/tanzania-constitution': { ns: 'tanzaniaConstitution', keywords: 'katiba ya tanzania, tume ya katiba, constitution of tanzania, katiba mpya' },
    '/constitution': { ns: 'constitution', keywords: 'world constitutions, comparative constitutional law, katiba' },
    '/journals': { ns: 'journals', keywords: 'constitutional journals, legal journals tanzania, katiba research' },
    '/books': { ns: 'books', keywords: 'constitutional books, law books, katiba books' },
    '/reports': { ns: 'reports', keywords: 'human rights reports, constitutional reports, tanzania laws' },
    '/cases': { ns: 'cases', keywords: 'tanzania case law, local courts, constitutional cases' },
    '/regional-cases': { ns: 'regionalCases', keywords: 'african court, regional courts, human rights judgments' },
    '/cuttings': { ns: 'cuttings', keywords: 'katiba cuttings, constitution news, newspaper cuttings' },
    '/audios': { ns: 'audios', keywords: 'katiba audio, constitutional discussions, legal podcasts' },
    '/videos': { ns: 'videos', keywords: 'katiba videos, constitutional debates, legal education' },
    '/other': { ns: 'other', keywords: 'legal articles, papers, dissertations, katiba resources' },
    '/search': { ns: 'searchPage', keywords: DEFAULT_KEYWORDS }
};

export const NOINDEX_PATHS = [
    '/login',
    '/register',
    '/dashboard',
    '/users',
    '/upload',
    '/timeline',
    '/media',
    '/material',
    '/roles',
    '/constitutions'
];

export const slugify = (text) => {
    const slug = String(text || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 80);
    return slug || 'document';
};

export const readPath = (id, title, documentType) => {
    const params = new URLSearchParams();
    if (documentType) params.set('type', documentType);
    const query = params.toString();
    return `/read/${id}/${slugify(title)}${query ? `?${query}` : ''}`;
};

export const canonicalUrl = (pathname = '/', search = '') => {
    const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
    return `${SITE_URL}${path}${search || ''}`;
};
